import { useState } from 'react';

export default function useUI() {
    const [sidebarIsOpen, setSidebarIsOpen] = useState(true);
    const [activeAccountId, setActiveAccountId] = useState<number | null>(null);
    const [activePolling, setActivePolling] = useState<boolean>(false);

    return {
        sidebarIsOpen,
        setSidebarIsOpen,
        activeAccountId,
        setActiveAccountId,
        activePolling,
        setActivePolling,
    };
}
